module.exports = __webpack_public_path__ + "img/australia-ill-defined-causes-male.bcaef7aa.png";